<div class="dashboard_cover" *ngIf="showContent">
    <div class="row m-0">
      <div *ngIf="!appDisable" [ngClass]="{'disableDiv': appDisable}" class="col-sm-2 col-md-2 col-lg-2 col-xs-4 pr-0">
        <div class="card card-shadow-sm" routerLink="/admin" routerLinkActive="active">
          <div class="card-body">
            <div class="dash-img-kat user-settings"></div>
            <h3 class="mt-3 m-0" i18n="Admin Tile | admin tile option in landing page. @@AdminTile">Admin</h3>
          </div>
        </div>
      </div>
      <div class="col-sm-2  col-md-2 col-lg-2 col-xs-4 pr-0">
        <!--19Feb2021-->
        <div class="card card-shadow-sm" routerLink="/import">
          <div class="card-body">
            <div class="dash-img-kat user-translate"></div>
            <h3 class="mt-3 m-0">Import</h3>
          </div>
        </div>
      </div>
      <div class="col-sm-2  col-md-2 col-lg-2 col-xs-4 pr-0">
        <div class="card card-shadow-sm" routerLink="/datamanagement">
          <div class="card-body">
            <div class="dash-img-kat data-processing"></div>
            <h3 class="mt-3 m-0">Data Management</h3>
          </div>
        </div>
      </div>
      <div class="col-sm-2 col-md-2 col-lg-2 col-xs-4 pr-0">
        <div class="card card-shadow-sm" routerLink="/contentManagement">
          <div class="card-body">
            <div class="dash-img-kat content-management"></div>
            <h3 class="mt-3 m-0" i18n="">Content Management </h3>
          </div>
        </div>
      </div>
  
      <div class="col-sm-2  col-md-2 col-lg-2 col-xs-4 pr-0" style="display: none;">
        <div class="card card-shadow-sm" routerLink="/export">
          <div class="card-body">
            <div class="dash-img-kat user-publish"></div>
            <h3 class="mt-3 m-0">Export</h3>
          </div>
        </div>
      </div>
      <div class="col-sm-2  col-md-2 col-lg-2 col-xs-4 pr-0">
        <div class="card card-shadow-sm" routerLink="/reporting">
          <div class="card-body">
            <div class="dash-img-kat user-reports"></div>
            <h3 class="mt-3 m-0">Reports</h3>
          </div>
        </div>
      </div>
  
  
    </div>
  </div>